import React, { useState } from "react";
import classNames from "classnames";
import { Col, Row } from "react-bootstrap/lib";
import newsearchfilter from "app/Search/Header/searchFilterNew/SearchFilterNew.scss";
import { LeftPanel } from "./LeftPanel";
import { RightPanel } from "./RightPanel";
import css from "../CustomFilterModal.scss";

/*
 * Copy of app/Search/Header/searchFilterNew/panel/MainPanel.js adapted for the
 * CustomFilterModal: reuses the SearchFilterNew.scss layout classes (wrapped in
 * dropdownBody so the panel styles apply), overrides the viewport-based panel
 * heights with modal-relative ones, and accepts an optional `topLeftContent`
 * node rendered above the category list (the Custom Summary section).
 */
export const MainPanel = ({ topLeftContent = null, hotkeysEnabled = true}) => {
  // State to track selected index
  const [selectedIndex, setSelectedIndex] = useState(0);

  // Function to handle item click
  const handleItemClick = index => {
    setSelectedIndex(index);
  };

  return (
    <div className={classNames(newsearchfilter.dropdownBody, css.panelBody)}>
      <Row className={classNames(newsearchfilter.row, css.fullHeightRow)}>
        <Col md={4} xs={12} className={classNames(newsearchfilter.col, css.fullHeightCol)}>
          <div className={css.leftColumn}>
            {topLeftContent}
            <div className={classNames(newsearchfilter.clsLeftBody, css.leftBodyScroll)}>
              <LeftPanel onItemClick={handleItemClick} />
            </div>
          </div>
        </Col>
        <Col md={8} xs={12} className={classNames(newsearchfilter.col, css.fullHeightCol)}>
          <div className={classNames(newsearchfilter.clsRightBody, css.rightBodyFull)}>
            <RightPanel selectedIndex={selectedIndex} hotkeysEnabled={hotkeysEnabled} />
          </div>
        </Col>
      </Row>
    </div>
  );
};
